/* import __COLOCATED_TEMPLATE__ from './suggestion-data-connector.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type { PulseAccordionSection } from 'glint/pulse';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';

interface Signature {
  Args: {
    section: PulseAccordionSection;
    sectionId: string;
    isOpen: boolean;
    onOpenSectionChange: (sectionId: string) => void;
  };
}

export default class SuggestionDataConnector extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare appService: AppService;

  @action
  navigateToCustomActions() {
    let appId = this.appService.app.id;
    let url = this.router.urlFor('apps.app.automation.fin-ai-agent.escalation', appId);
    safeWindowOpen(url, '_blank');
  }

  @action
  openSampleApiSection() {
    this.args.onOpenSectionChange('4');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SuggestionAccordionItems::SuggestionDataConnector': typeof SuggestionDataConnector;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/suggestion-accordion-items/suggestion-data-connector': typeof SuggestionDataConnector;
  }
}
